import { useState, useCallback, useRef } from "react";
import { useFocusTrap } from "@thebouqs/hooks";
export function useDrawer(params) {
  var {
    direction: paramsDirection,
    initialFocusRef,
    finalFocusRef
  } = params;
  var drawerIsOpen = useRef(false); // sets drawer state without refreshing

  var drawerRef = useRef(null);
  var direction = paramsDirection === "left" ? "-" : "+";
  var [displayDrawer, setDisplayDrawer] = useState(false); // render drawer even if partially open

  var open = () => {
    // transform in another thread to allow animation
    drawerIsOpen.current = true;
    setDisplayDrawer(true);
    var el = drawerRef.current;

    if (!el) {
      return;
    }

    setTimeout(() => {
      el.style.transform = "translateX(0)";
    }, 1);
  };

  var close = () => {
    drawerIsOpen.current = false;
    var el = drawerRef.current;
    el.style.transform = "translateX(" + direction + "100%)";
  };

  var onDrawerRef = useCallback(node => {
    if (node !== null) {
      // lets the animation finish before toggling the drawer
      var onTransitionEnd = () => {
        if (drawerIsOpen.current === false) {
          setDisplayDrawer(false);
        }
      };

      drawerRef.current = node;
      var el = drawerRef.current;
      el.addEventListener("transitionend", onTransitionEnd);

      if (displayDrawer) {
        open();
      }

      return () => {
        el.removeEventListener("transitionend", onTransitionEnd);
      };
    }
  }, [displayDrawer]);
  var onBlur = useFocusTrap({
    node: drawerRef,
    initial: initialFocusRef,
    final: finalFocusRef,
    onClose: close,
    trap: displayDrawer
  });
  return {
    open: displayDrawer,
    onOpen: open,
    onClose: close,
    onRef: onDrawerRef,
    drawerMainProps: {
      open: displayDrawer,
      role: "alert",
      display: displayDrawer ? "block" : "none",
      onOverlayClick: close,
      "data-testid": "drawer-main",
      className: "drawer-main",
      onBlur
    },
    handleProps: {
      "aria-haspopup": true,
      "aria-expanded": displayDrawer,
      className: "drawer-open-button",
      onClick: open
    },
    closeButtonProps: {
      className: "drawer-close-button",
      onClick: close
    },
    drawerContentProps: {
      className: "drawer-content"
    }
  };
}
//# sourceMappingURL=useDrawer.js.map